import Component from '../../js/_Component';
import Modal from '../../js/util/_Modal';

export default class PageBoatPhotos extends Component {
	/** The photos in the gallery. */
	private photos: NodeListOf<HTMLElement>;

	/** The hidden template which holds the content to use in the modal. */
	private modalTemplate: HTMLTemplateElement;

	constructor(element: HTMLElement) {
		super(element);

		this.photos = element.querySelectorAll('.c-page-boat-photos__photo');
		this.modalTemplate = element.querySelector('.c-page-boat-photos__modal');

		/** The direct children of the modal template. */
		const modalPanels = this.modalTemplate.content.children;

		// Attach a click handler to each photo that will create and open a modal.
		Array.from(this.photos).forEach((photo, index) => {
			photo.addEventListener('click', () => {
				// Clone each modal panel.
				const panelArray = Array.from(modalPanels)
					.map((modalPanel) => modalPanel.cloneNode(true) as HTMLElement);

				// Create a new modal with the array of clones.
				const modal = new Modal(panelArray);

				// Open the modal at the index of the item that was clicked.
				modal.showPanel(index);
			});
		});
	}
}

Component.register(PageBoatPhotos, 'PageBoatPhotos');
